import Model from "./model";

export default new Model({
  resource: "tarja",
  path: "tarjas",//direccion dentro de la respuesta del get all()
  dateable: true,
  inputs:[
    {label:"ID", nameAttr:"id", default:0, required: true, type:"text", width: 60},
    {label:"Fecha", nameAttr:"fecha", default:"-", required: true, type:"date", width: 150},
    {label:"Jornada", nameAttr:"jornada", default:1, required: true, type:"text", width: 150},
    {label:"Rendimiento", nameAttr:"rendimiento", default:0, required: false, type:"text", width: 150},
    {label:"Valor Día", nameAttr:"valor_dia", default:0, required: false, type:"text", width: 100},
    {label:"Valor Unidad", nameAttr:"valor_unidad", default:0, required: false, type:"text", width: 100},
    {label:"Horas Extras", nameAttr:"horas_extras", default:0, required: false, type:"text", width: 100},
    {label:"Bono", nameAttr:"bono", default:0, required: false, type:"text", width: 100},
    {label:"Valor total", nameAttr:"valor_total", default:0, required: false, type:"text", width: 100},

    {label:"Trabajador", nameAttr:"trabajador", default:null, required: true, type:"select", model:"trabajadorModel", searchPath: "nombre", width: 150},
    {label:"Sub Labor", nameAttr:"sub_labor_id", default:null, required: true, type:"select", model:"subLaborModel", searchPath: "nombre", width: 150},
    {label:"Centro Costo", nameAttr:"centro_costo_id", default:null, required: true, type:"select", model:"centrosCostoModel", searchPath: "nombre", width: 150},
  ]
});
